import { Controller } from "stimulus"
import notify from "../packs/notify"
export default class extends Controller {
  static targets = ['modalElement']

  connect(){
    $(this.modalElementTarget).modal('show')
  }
  
  submitEnd(e){
    this.setLoadingPage(true)
    if(e.detail.success){
      e.detail.fetchResponse.response.json()
      .then( res => notify({status: res.status, message: res.message }))
      .finally(()=> this.setLoadingPage(false))
      $(this.modalElementTarget).modal('hide')
    }else{
      this.setLoadingPage(false)
    }
  }
  
  disconnect(){
    $(this.modalElementTarget).modal('hide')
  }

  setLoadingPage(bool) {
    const loader = this.modalElementTarget.querySelector('.loading-backdrop')
    
    if( !loader ) return

    if (bool) {
      $(loader).delay(5000).queue( function (){
        $(loader).removeClass('d-none');
      })
    } else {
      $(loader).clearQueue().addClass('d-none');
    }
  }
}